module.exports = __webpack_public_path__ + "img/home-build-img.a31db6d9.png";